/**
 * Zod input schemas: admin. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
import { EmailSchema } from './primitives.js';
export const AdminSendTestEmailSchema = z.object({
    address: z.string().trim().toLowerCase().email(),
});
export const AdminImpersonateSchema = z.object({
    targetEmail: z.string().trim().toLowerCase().email(),
});
/** Set/clear a user's manual avatar. photoDataUrl: a small data:image/* URL
 *  (client-resized), or null to clear (revert to the Google photo). Capped so
 *  it stays well under the Firestore doc limit. */
export const AdminSetUserPhotoSchema = z.object({
    targetEmail: EmailSchema,
    photoDataUrl: z
        .string()
        .regex(/^data:image\/(png|jpeg|webp);base64,/, 'Must be a PNG/JPEG/WebP data URL')
        .max(200_000, 'Image too large — it should be resized client-side first')
        .nullable(),
});
// ===========================================================================
// PRODUCT PROJECTS
// ===========================================================================
//# sourceMappingURL=admin.js.map